import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { TrialExpiredModal } from '../TrialExpiredModal';
import { hideWidget, showWidget } from '../../lib/widgetVisibility';

interface TrialExpiryGuardProps {
  children: React.ReactNode;
}

const EXEMPT_PREFIXES = ['/subscription', '/settings'];

export const TrialExpiryGuard: React.FC<TrialExpiryGuardProps> = ({ children }) => {
  const location = useLocation();
  const { user } = useAuthStore();

  const isExpired =
    user?.plan === 'trial' &&
    !!user?.trial_ends_at &&
    new Date(user.trial_ends_at) <= new Date();

  const isExempt = EXEMPT_PREFIXES.some(
    (p) => location.pathname === p || location.pathname.startsWith(p + '/')
  );

  useEffect(() => {
    if (isExpired && !isExempt) {
      hideWidget();
    } else {
      showWidget();
    }
  }, [isExpired, isExempt]);

  return (
    <>
      {children}
      {isExpired && !isExempt && <TrialExpiredModal />}
    </>
  );
};
